import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath, current_client_config, currentIP, MOBILE_CHECKIN_CATEGORY } from "../../config/Constant";
import { setRenderFlashMessage, setRenderLoader } from "./appConfigAction";
import { setInitAppLogout, setIsAutoLoggedIn, setShowLoginModal } from "../Reducers/appConfigReducer";
import { setGuestRoomData } from "../Reducers/guestRoomReducer";
import { makeLayoutApiCalls } from "../../js/fetchAppConfigs";
import { sendAnalytics } from "./analyticsAction";
import i18n from 'i18next';

export const linkToRoom = (guestDetailsObj = {}, callback, accessCode, guestId) => {

    const guestDetails = { candoAccompanyLogin: true, candoOtpFlow: true, ...guestDetailsObj };

    return async (dispatch, getState) => {

        const { isAutoLoggedIn } = getState().appConfigSlice;

        const { webAppWidgetsInfo, loginToRoomOtpRequiredFlag } = getState().deviceConfigSlice;
        const accompanyGuestFlowEnabled = webAppWidgetsInfo?.mobileCheckInConfigs?.accompanyGuestFlowEnabled;

        const sessionToken = await AsyncStorage.getItem("sessionToken");

        try {


            const header = {
                'Content-Type': 'application/json',
                sessionToken: sessionToken
            }
            if (loginToRoomOtpRequiredFlag && guestDetails.candoOtpFlow) {
                header.enableOtpFlow = true;
                header.requestForOtp = accessCode ? false : true;
            }



            let guestNotVerified = false;
            let id = null;
            if (accompanyGuestFlowEnabled && guestDetails.candoAccompanyLogin) {
                if (guestId == "master") {
                    guestNotVerified = false;
                } else {
                    guestNotVerified = !Boolean(guestId);
                    id = guestId;
                }

                header.requestForOtp = accessCode ? false : true;
            }

            const payload = {
                guestName: guestDetails.lastName,
                roomNo: guestDetails.roomNumber,
                accessCode: accessCode || "",
                guestNotVerified: guestNotVerified,
                id: id,
            };

            const response = await clientConfigPath.post("/guestDevice/linkToRoom", {
                header: header,
                payload: payload,
            });

            const guestToken = response?.data?.payload?.guestToken;

            if (guestToken) {
                await AsyncStorage.setItem("guestToken", guestToken);

                await AsyncStorage.setItem("connectorIP", currentIP);
                await AsyncStorage.setItem("clientId", current_client_config);

                if(isAutoLoggedIn) dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "Auto Login - Success", {...guestDetails}));

                callback(true);
                dispatch(makeLayoutApiCalls());
            } else if (response?.data?.header?.status?.code == "FAILED" && response.data.payload?.failureReason == "Multiple Guest") {
                const updatedGuestList = response.data.payload.guestList.map(item => {
                    if (item.id == null) {
                        item.id = "master";
                    }
                    return item;
                });
                callback(false, response.data.payload?.failureReason);

                dispatch(setGuestRoomData({
                    guestDetails: guestDetails,
                    activeState: 'multiple_guest',
                    guestList: updatedGuestList,
                }));
                dispatch(setShowLoginModal(true));
            } else if (response?.data?.header?.status?.code == "FAILED" && response.data.payload?.failureCode == "OTP") {
                callback(false, response.data.payload?.failureReason);

                dispatch(setGuestRoomData({
                    guestDetails: guestDetails,
                    activeState: 'otp',
                    otpMessage: response.data.payload?.failureReason,
                }));
                dispatch(setShowLoginModal(true));
            } else {
                const errorMessage = response?.data?.header?.status.msg || "Something went wrong";
                callback(false, errorMessage)

                if(isAutoLoggedIn) dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "Auto Login - Failed", {errorMessage: errorMessage, ...guestDetails}));
                dispatch(setIsAutoLoggedIn(false));
                dispatch(setRenderFlashMessage(true, { type: "danger", message: errorMessage }));
            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
            
            if(isAutoLoggedIn) dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "Auto Login - Failed", {errorMessage: errorMessage, ...guestDetails}));
            dispatch(setIsAutoLoggedIn(false));
            dispatch(setRenderFlashMessage(true, { type: "danger", message: errorMessage || "Something went wrong" }));
        }
    }
};

export const logoutUserFunc = (callback) => {


    return async (dispatch, getState) => {

        const { isOnline } = getState().appConfigSlice;
        if (!isOnline) {
            callback(false, i18n.t('offlineModal.subtitle'));
            return;
        }
        
            
        try {
            const sessionToken = await AsyncStorage.getItem("sessionToken");

            const response = await clientConfigPath.post("/guestDevice/delink", {
                "header": {
                    "sessionToken": sessionToken,
                },
            });

            if (response?.status == 200) {
                callback(true);
                dispatch(setInitAppLogout(true));
            } else {
                const errorStatus = response?.data?.header?.status.msg || "Something went wrong";
                if (callback) {
                    callback(false, errorStatus);
                }
            }
        } catch (error) {
            const errorStatus = error.response?.data?.header?.status.msg || "Something went wrong";
            console.log("Logout API failed", errorStatus);

            if (callback) {
                callback(false, errorStatus);
            }
        }
    };
};
